// extracted by mini-css-extract-plugin
export default {"component":"index-module__component--jtwsr","component--bigger":"index-module__component--bigger--1H5QT","input":"index-module__input--4mv2O"};